import {clearHologramPageSnapshots} from "./hard_logout.mjs";

const SEAL_KEY = "arbeidsmarktscan_sealed";

let guardStarted = false;

function personaliaPath(pathname) {
  if (pathname.includes("/perspectief-taxateurs/")) {
    return "/perspectief-taxateurs/scan/personalia";
  }
  return "/arbeidsmarktscan/personalia";
}

function lockedSurveyPath(pathname) {
  if (pathname.startsWith("/arbeidsmarktscan/")) {
    if (
      pathname === "/arbeidsmarktscan/personalia" ||
      pathname === "/arbeidsmarktscan/voltooid"
    ) {
      return false;
    }
    return true;
  }

  if (pathname.startsWith("/perspectief-taxateurs/scan/")) {
    if (
      pathname === "/perspectief-taxateurs/scan/personalia" ||
      pathname === "/perspectief-taxateurs/scan/voltooid"
    ) {
      return false;
    }
    return true;
  }

  return false;
}

/** Call on Bedankt: wipe SPA snapshots and block soft-back into the scan. */
export async function sealSurveyFlow() {
  sessionStorage.setItem(SEAL_KEY, "1");
  await clearHologramPageSnapshots();
}

/** Call when starting/resuming personalia so a new scan can use history again. */
export function clearSurveySeal() {
  sessionStorage.removeItem(SEAL_KEY);
}

function bounceIfSealed() {
  if (sessionStorage.getItem(SEAL_KEY) !== "1") return;
  if (!lockedSurveyPath(location.pathname)) return;
  location.replace(personaliaPath(location.pathname));
}

/**
 * After pay, browser back restores Hologram snapshots and skips server middleware.
 * Force a full navigation to personalia for sealed flows.
 */
export function startSealedSurveyBackGuard() {
  if (guardStarted) return;
  guardStarted = true;

  window.addEventListener("popstate", bounceIfSealed, true);
  window.addEventListener("pageshow", bounceIfSealed);
}
